import { ArrowRight, Check, PlayCircle } from 'react-feather';
import { useTranslation } from 'react-i18next';

import { assetUrl } from '../../Shared/helpers';
import { AButton } from '../../Shared/UI/Button';
import { Card } from '../../Shared/UI/Card';
import { Icon } from '../../Shared/UI/Icon';

export const CharityBanner = () => {
  const { t } = useTranslation();

  return (
    <Card className="!bg-gradient-to-tr from-emerald-500 to-emerald-300 text-white overflow-hidden !p-0" shadow={false} border={false}>
      <img src={assetUrl('images/website/phone-bg.svg')}className="w-full max-w-[575px] absolute left-0 bottom-0 sm:left-1/2 sm:-bottom-3/4 opacity-50 z-0" />

      <div className="grid sm:grid-cols-2 relative z-1">
        <div className="p-6 sm:p-16">
          <h3 className="flex items-center text-xl mb-2 text-white">
            {t('frontend:homepage.add_charity_to_supporta')}
          </h3>
          <p className="flex space-x-2 mb-1">
            <Icon className="text-emerald-100 shrink-0 mt-1">
              <Check />
            </Icon>
            <span>
              {t('frontend:homepage.charity_accept_donations_usp')}
            </span>
          </p>
          <p className="flex space-x-2 mb-1">
            <Icon className="text-emerald-100 shrink-0 mt-1">
              <Check />
            </Icon>
            <span>
              {t('frontend:homepage.charity_connect_with_sports_events')}
            </span>
          </p>
          <p className="flex space-x-2 mb-4">
            <Icon className="text-emerald-100 shrink-0 mt-1">
              <Check />
            </Icon>
            <span>
              {t('frontend:homepage.charity_crowdfunding_platform')}
            </span>
          </p>
          <p>
            <AButton
              href="https://about.supporta.com"
              variant="secondary"
              className="!border-none shadow-sm mr-2 mb-2"
            >
              {t('frontend:homepage.connect_charity')}
              <Icon className="ml-1">
                <ArrowRight />
              </Icon>
            </AButton>
            <AButton
              href="https://meetings-eu1.hubspot.com/tom-koedooder/supporta-demo?uuid=c82ebefb-47ac-4269-ae1d-60d5126901e2"
              variant="tertiary"
              className="!text-white !border-emerald-200 hover:!border-emerald-100"
              target="_blank"
              rel="noopener noreferrer"
            >
              {t('frontend:homepage.request_demo')}
              <Icon className="ml-1">
                <PlayCircle />
              </Icon>
            </AButton>
          </p>
        </div>
        <div className="sm:overflow-hidden relative">
          <img
            src={assetUrl('images/website/phone.png')}
            className="max-w-[300px] mx-auto mt-4 sm:mt-0 sm:w-[400px] sm:max-w-none sm:absolute sm:top-6 sm:left-1/2 sm:-ml-[200px]"
            alt="Supporta"
          />
        </div>
      </div>
    </Card>
  );
};
